export const HEADER_HEIGHT_MOBILE = 56
export const HEADER_HEIGHT_DESKTOP = 64
export const BOTTOM_NAV_HEIGHT = 56
